import React from 'react';
import CaseList from '../components/CaseList';

const ServiceCases: React.FC = () => {
  return <CaseList caseType="service" title="Service Cases" icon="🔧" color="purple" />;
};

export default ServiceCases;
